import { render, staticRenderFns } from "./OrganizationEmployeesTab.vue?vue&type=template&id=3f4923a2&scoped=true"
import script from "./OrganizationEmployeesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationEmployeesTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationEmployeesTab.vue?vue&type=style&index=0&id=3f4923a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4923a2",
  null
  
)

export default component.exports